import * as React from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { UserSelectorInput } from 'modules/core/components/Inputs/UserSelector'
import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'
import users from 'modules/core/store/collections/users'

import { ActivatePayload } from 'modules/app_store/lib/SubscriptionAddonInstaller'

interface Props {
  onSuccess: (payload?: ActivatePayload | null | undefined) => Promise<boolean>
  onClose: () => void
}

const ComplaintsManagerModal = ({ onSuccess, onClose }: Props) => {
  const [complaintsManagerIds, setComplaintsManagerIds] = React.useState<number[]>([])

  const onSubmit = () => {
    onSuccess({
      complaints_manager_ids: complaintsManagerIds,
    })
    onClose()
  }

  return (
    <Modal
      illustration="user-tie"
      title={i18n.t('app_store_v2.apps.complaints.complaints_manager_install_modal.title')}
      description={i18n.t(
        'app_store_v2.apps.complaints.complaints_manager_install_modal.description'
      )}
      onClose={onClose}
      onSubmit={onSubmit}
      footer={
        <>
          <Button onClick={onClose} type="secondary">
            {i18n.t('common.cancel')}
          </Button>
          <Button disabled={!complaintsManagerIds.length} submit>
            {i18n.t('app_store_v2.apps.complaints.complaints_manager_install_modal.submit')}
          </Button>
        </>
      }
    >
      <Box gap="s24">
        <UserSelectorInput
          label={i18n.t('app_store_v2.apps.complaints.complaints_manager_install_modal.label')}
          onSubmit={setComplaintsManagerIds}
          selectedIds={complaintsManagerIds}
          users={users.notTerminated}
        />
      </Box>
    </Modal>
  )
}

export default observer(ComplaintsManagerModal)
